<script setup lang="ts">
type HeroLink = {
  label: string;
  to: string;
};

withDefaults(defineProps<{
  headline?: string;
  title: string;
  description: string;
  links?: HeroLink[];
}>(), {
  headline: "",
  links: () => [],
});
</script>

<template>
  <section class="rounded-[26px] border border-slate-200 bg-[radial-gradient(circle_at_top_left,_rgba(245,158,11,0.12),_transparent_36%),linear-gradient(135deg,_#fffdf7_0%,_#ffffff_48%,_#fff7ed_100%)] p-5 shadow-[0_20px_60px_-40px_rgba(245,158,11,0.45)] dark:border-slate-700 dark:bg-[radial-gradient(circle_at_top_left,_rgba(245,158,11,0.16),_transparent_32%),linear-gradient(135deg,_#020617_0%,_#111827_56%,_#1f2937_100%)] md:rounded-[30px] md:p-8">
    <p v-if="headline" class="text-xs font-semibold uppercase tracking-[0.24em] text-amber-700 dark:text-amber-300">
      {{ headline }}
    </p>
    <h1 class="mt-2 text-2xl font-black tracking-tight text-slate-900 md:mt-3 md:text-5xl dark:text-white">
      {{ title }}
    </h1>
    <p class="mt-3 max-w-4xl text-sm leading-6 text-slate-700 md:mt-4 md:text-base dark:text-slate-300">
      {{ description }}
    </p>

    <div v-if="links.length" class="mt-5 flex flex-wrap gap-3 md:mt-6">
      <NuxtLink
        v-for="link in links"
        :key="link.to"
        :to="link.to"
        class="rounded-full border border-amber-200 bg-white px-4 py-2 text-sm font-semibold text-amber-800 transition hover:border-amber-300 hover:bg-amber-50 dark:border-amber-800 dark:bg-slate-900/80 dark:text-amber-200 dark:hover:border-amber-700 dark:hover:bg-slate-950"
      >
        {{ link.label }}
      </NuxtLink>
    </div>
  </section>
</template>
